import React from 'react';
import classes from './button.css';

const Button=(props)=>(<button className={`${classes.Button} ${classes[props.btnType]}`}
	onClick={props.click}>
	{props.children}
	</button>)


export default Button;


// WEBPACK FOOTER //
// ./src/components/UI/button/button.jsx